import 'regenerator-runtime/runtime';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';

const container = document.getElementById('hyper');

if (['prod', 'develop'].includes(import.meta.env.VITE_MODE)) {
	Sentry.init({
		dsn: 'https://2f2fe95c84b3a114e143c7aae30bc4b7@o4508746119905280.ingest.de.sentry.io/4508746124165200',
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
			Sentry.replayCanvasIntegration(),
		],
		// Tracing
		tracesSampleRate: 1.0, //  Capture 100% of the transactions
		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		tracePropagationTargets: [
			'localhost',
			'http://localhost:3000',
			'http://localhost:3001',
			'http://localhost:3002',
			'https://realtime-service-develop.iagro.lat',
			/^https:\/\/realtime-service-develop\.iagro\.lat\/develop\/.*/,
			/^https:\/\/realtime-service-develop\.iagro\.lat\/production\/.*/,
		],
		// Session Replay
		replaysSessionSampleRate: import.meta.env.VITE_MODE === 'prod' ? 1.0 : 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
		environment: import.meta.env.VITE_MODE,
	});
}

if (container) {
	const root = createRoot(container);
	root.render(
		<BrowserRouter basename={process.env.PUBLIC_URL}>
			<App />
		</BrowserRouter>
	);
}
